import { routesPath } from '../../constants/routesPath';

export const getFooterLinks = t => ({
    brand: {
        name: t('brand.name'),
        description: t('brand.description'),
        logo: {
            src: '/Logo.svg',
            alt: t('brand.logoAlt'),
            width: 120,
            height: 60,
        },
    },
    poweredBy: {
        text: t('poweredBy.text'),
        link: `${routesPath.FOOTER.INTERCODE}`,
        name: 'InterCode',
    },
    sections: [
        {
            title: t('sections.pages.title'),
            links: [
                { href: `${routesPath.FOOTER.DASHBOARD}`, label: t('sections.pages.home') },
                { href: `${routesPath.FOOTER.PAYMENT}`, label: t('sections.pages.pricing') },
                { href: `${routesPath.FOOTER.BLOG}`, label: t('sections.pages.blog'), external: true },
                {
                    href: `${routesPath.FOOTER.BLOG_ARCHIVE}`,
                    label: t('sections.pages.blogArchive'),
                    external: true,
                },
            ],
        },
        {
            title: t('sections.company.title'),
            links: [
                { href: `${routesPath.FOOTER.ABOUT_US}`, label: t('sections.company.aboutUs'), external: true },
                { href: `${routesPath.FOOTER.CONTACT}`, label: t('sections.company.contact'), external: true },
                { href: `${routesPath.FOOTER.FAQ}`, label: t('sections.company.faq'), external: true },
                { href: `${routesPath.FOOTER.SUPPORT}`, label: t('sections.company.support'), external: true },
            ],
        },
        {
            title: t('sections.resources.title'),
            links: [
                {
                    href: `${routesPath.FOOTER.SAMPLE_REPORT}`,
                    label: t('sections.resources.sampleReport'),
                },
                { href: `${routesPath.FOOTER.GUIDES}`, label: t('sections.resources.guides'), external: true },
                {
                    href: `${routesPath.FOOTER.PRIVACY_POLICY}`,
                    label: t('sections.resources.privacyPolicy'),
                    external: true,
                },
            ],
        },
    ],
    bottom: {
        cookieStatement: {
            href: `${routesPath.FOOTER.COOKIE_STATEMENT}`,
            label: t('bottom.cookieStatement'),
            external: true,
        },
    },
});
